import { Theme, makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import { MEDIA_BREAKPOINTS } from 'modules/Types';
import Colors from "modules/Colors";
import Sty from 'modules/Sty';

const useStyles = makeStyles((_theme: Theme) => ({
  tableContainer: {
    borderRadius: 6,
    maxHeight: 458,
  },
  tableHead: {
    color: Colors.greyDark,
  },
  withBorderBottom: {
    borderBottom: Sty.border,
  },
  noBorderBottom: {
    borderBottom: "none",
  },
  downloadInvoiceButton: {
    textTransform: "none",
    borderRadius: 48,
    backgroundColor: "white",
    color: Colors.purple,
    shadowBox: "none",
    "&:hover": {
      backgroundColor: 'white',
      color: Colors.purple,
    },
  },
  imgStylesUserCircle: {
    width: 50,
    height: 50,
    objectFit: "cover",
    borderRadius: "50%",
  },
}))

export interface IconProps {
  margin?: string
}

interface CardProps {
  padding?: string
  borderRadius?: string
  marginBottom?: string
  marginTop?: string
  width?: string
  maxWidth?: string
}

export const Card = styled.div<CardProps>`
  display: "flex";
  flex-direction: column;
  border-radius: ${({ borderRadius }) => borderRadius || "8px"};
  padding: ${({ padding }) => padding || "40px 24px"};
  background-color: #ffff;
  width: ${({ width }) => width || "86%"};
  max-width: ${({ maxWidth }) => maxWidth };
  margin-left: auto;
  margin-right: auto;
  margin-top: ${({ marginTop }) => marginTop || "48px"};
  margin-bottom: ${({ marginBottom }) => marginBottom || "16px"};
  ${MEDIA_BREAKPOINTS.mobileView} {
    border-radius: 0px;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    padding-bottom: 16px;
    width: 100%;
  }
`

export const StyledNavBar = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom-width: 1px;
  border-color: rgba(209, 213, 219, 1);
  flex-grow: 1;
  margin-top: 32px;
`

export default useStyles
